<template>
	<v-container fluid class="ma-0 pa-0">
		<Header />
    <v-col class="pa-0" id="main_content_maxwidthset" cols="12">
			<v-col class="ma-0 pa-2 pt-9" cols="12" align="left">
				<v-col class="ma-0 pa-0" cols="12">
					{{'X-API-KEY'}}
				</v-col>
				<v-row class="ma-0 pa-0 mt-1" align="center">
					<v-col class="ma-0 pa-0" cols="6">
						<input id="input_grey" v-model="xApiKey" placeholder="x-api-key를 입력하세요">
					</v-col>
					<v-col class="ma-0 pa-0 pl-2" cols="1">
            <v-btn width="100%" height="2.5rem" id="blue_btn"
							@click="keyInputFunc">
              {{'저장'}}
            </v-btn>
          </v-col>
				</v-row>

				<v-col class="ma-0 pa-0 mt-7" cols="12">
					{{'Role Group Name'}}
				</v-col>
				<v-col class="ma-0 pa-0 mt-1" cols="8" style="width:100%;">
					<v-select background-color="#272727" dark v-model="selectedRoleGroupKey"
						:items="roleGroupNameList" dense hide-details outlined 
						item-text="name" item-value="key"
					></v-select>
				</v-col>

				<v-col class="ma-0 pa-0 mt-7" cols="8">
					<v-row class="ma-0 pa-0" align="center" justify="space-between">
						<v-col class="ma-0 pa-0" cols="auto">
              <v-row class="ma-0 pa-0" align="center">
						    <v-col class="ma-0 pa-0" cols="auto">
							    {{'Role Detail'}}
                </v-col>
                <v-col class="ma-0 pa-0 ml-2" cols="auto">
                  <v-tooltip right>
                    <template v-slot:activator="{on, attrs}">
                      <v-icon dark v-bind="attrs" v-on="on">
                        mdi-information-outline
                      </v-icon>
                    </template>
                    <span> ✕ : not avaiable </span> <br>
                    <span> ○ : avaiable </span> <br>
                    <span> C1 : changable (default true) </span> <br>
                    <span> C2 : changable (default false) </span>
                  </v-tooltip>
                </v-col>
              </v-row>
						</v-col>
            <v-col v-if="roleList.created == null" class="ma-0 pa-0" cols="auto">
              <v-btn width="5rem" height="2rem" id="blue_btn"
                @click="saveRole()">
                {{'저장'}}
              </v-btn>
            </v-col>
						<v-col v-else-if="roleModify != true" class="ma-0 pa-0" cols="auto">
							<v-btn width="5rem" height="2rem" id="blue_btn"
								@click="changeToModify()">
								{{'수정'}}
							</v-btn>
						</v-col>
            <v-col v-else class="ma-0 pa-0" cols="auto">
							<v-btn width="5rem" height="2rem" id="grey_btn"
								@click="cancelBtn()">
								{{'취소'}}
							</v-btn>
							<v-btn class="ml-2" width="5rem" height="2rem" id="blue_btn"
								@click="modifyRole()">
								{{'저장'}}
							</v-btn>
            </v-col>
					</v-row>
				</v-col>
				<v-col class="ma-0 pa-0" cols="8">
					<table id="role_table">
						<thead>
							<!-- <th>{{'ID'}}</th> -->
							<th>{{'Role List (PRIVATE_STORE_PARENTAL_ADMIN)'}}</th>
							<th>{{'Availability'}}</th>
						</thead>
            <template v-if="areaLoading == true">
              <v-skeleton-loader
							:boilerplate="false" elevation="0" dark 
							type="list-item-three-line, list-item-two-line, list-item-three-line"
						></v-skeleton-loader>
            </template>
            <template v-else-if="selectedRoleGroupKey == null">
              <tbody>
                <tr>
                  <td>{{'데이터가 없습니다'}}</td>
                </tr>
              </tbody>
            </template>
						<template v-else-if="roleList.created != null && roleModify != true">
							<tbody>
								<tr v-for="(item , index) in roleMap" :key="index">
									<!-- <td>{{item.id}}</td> -->
									<td>{{item[0]}}</td>
									<td class="td_availability" v-if="item[1] == 0">
                    {{'✕'}}
                  </td>
									<td class="td_availability" v-else-if="item[1] == 1">
                    {{'○'}}
                  </td>
									<td class="td_availability" v-else-if="item[1] == 2">
                    {{'C1'}}
                  </td>
									<td class="td_availability" v-else>
                    {{'C2'}}
                  </td>
								</tr>
							</tbody>
						</template>
            <template v-else-if = "roleModify == true">
              <tbody>
                <tr v-for="(item, index) in roleMap" :key="index">
                  <td>{{item[0]}}</td>
									<td class="td_availability">
                    <v-select background-color="#272727" dark v-model="item[1]" 
				      				:items="availability" dense hide-details outlined
				      				item-text="label" item-value="value">
                    </v-select>
                  </td>
                </tr>
              </tbody>
            </template>
						<template v-else>
							<tbody>
								<tr v-for="(item, index) in roleMap" :key="index">
									<!-- <td> - </td> -->
									<td>{{item[0]}}</td>
									<td class="td_availability">
                    <v-select background-color="#272727" dark v-model="item[1]"
				      				:items="availability" dense hide-details outlined 
				      				item-text="label" item-value="value">
                    </v-select>
                  </td>
								</tr>
							</tbody>
						</template>
					</table>
				</v-col>
			</v-col>
		</v-col>
		<AddRoleDialog :dialogVisible="addRoleDialogVisible"
			:roleGroupName="selectedRoleGroupName" :roleGroupKey="selectedRoleGroupKey"
			@visible="addRoleDialogVisibleFunc" />
	</v-container>
</template>

<script>
import mixin from '@/mixin';
import Header from './Header.vue';
import AddRoleDialog from './AddRoleDialog.vue';
export default {
	components: {
		Header, AddRoleDialog
	},
	mixins: [mixin.common],
	data: () => ({
		addRoleDialogVisible: false,
		xApiKey: '',
		roleGroupNameList: [],
		selectedRoleGroupKey: null,
		selectedRoleGroupName: null,
		roleList: {},
    roleMap: [],
    accountRoleList: [],
    availability: [
      {label: "✕", value: "0"},
      {label: "○", value: "1"},
      {label: "C1", value: "2"},
      {label: "C2", value: "3"}
    ],
    roleModify: false,
    areaLoading:false,
	}),
	watch: {
		'selectedRoleGroupKey': function(key) {
			if(key != null) {
				this.fetchRoleGroup(key);
				this.roleGroupNameList.forEach((roleItem) => {
					if(roleItem.key == key) {
						this.selectedRoleGroupName = roleItem.name;
					}
				});
			}
		}
	},
	mounted() {
		if(this.$store.state.userData.admin.xApiKey != null
			|| this.$store.state.userData.admin.xApiKey != undefined) {
			this.xApiKey = this.$store.state.userData.admin.xApiKey;
			this.fetchData();
		}
	},
	methods: {
		async keyInputFunc() {
			if(this.xApiKey == '') {
				this.$dialog.message.warning('X-API-KEY를 입력해주세요', {
					position: 'top', timeout: 2000
				});
				return;
			}
			await this.$store.commit('setAdmin', {
				xApiKey: this.xApiKey
			});
			this.$dialog.message.info('X-API-KEY 저장 성공', {
				position: 'top', timeout: 2000
			});
			this.fetchData();
		},
		addRoleDialogVisibleFunc(visible) {
			this.addRoleDialogVisible = visible;
			this.fetchRoleGroup(this.selectedRoleGroupKey);
		},
		async fetchData() {
			let params = {};
			await this.networkController.getAllRoleGroupList(params)
			.then(async (res) => {
				this.roleGroupNameList = res.data;
			}).catch(error => { });
		},
		async fetchRoleGroup(key) {
			let params = {};
			await this.networkController.getRoleGroup(params, key)
			.then(async (res) => {
				console.log('%cRoleList\n', "color:#008DD0;", res.data);
				this.roleList = res.data;
        this.roleMap = Object.entries(this.roleList.authGroup);
			}).catch(error => { });
		},
		addDialogCall() {
			if(this.selectedRoleGroupKey != null) {
				this.addRoleDialogVisible = true;
			} else {
				this.$dialog.message.warning('먼저 Role Group Name을 선택해주세요', {
					position: 'top', timeout: 2000
				});
			}
		},
		async roleDelete(roleId, index) {
			await this.$dialog.confirm({
				text: '해당 Role을 삭제 하시겠습니까?',
				title: 'Role 삭제',
				actions: {
					false: { color: 'white', text: '취소',},
					true: {
						color: '#008DD0', text: '확인',
						handle: async () => {
							let params = {};
							await this.networkController.deleteRole(params, roleId)
							.then(async (res) => {
								this.roleList.splice(index, 1);
							}).catch(error => { });
						}
					}
				}
			});
		},
    changeToModify() {
      this.roleModify = true;
    },
    async saveRole() {
      this.roleModify = false;
      this.areaLoading = true;
      let authGroupMap = Object.fromEntries(this.roleMap);
      this.roleList.authGroup = authGroupMap
      let params = this.roleList;
			await this.networkController.addRole(params)
			.then(async (res) => {
				this.fetchRoleGroup(this.selectedRoleGroupKey);
				this.areaLoading = false;
				this.$dialog.message.success('저장되었습니다', {
          position: 'top', timeout: 3000
        });
			}).catch(error => { });
    },
    async modifyRole() {
      this.roleModify = false;
      this.areaLoading = true;
      let authGroupMap = Object.fromEntries(this.roleMap);
      this.roleList.authGroup = authGroupMap
      let params = this.roleList;
			await this.networkController.addRole(params)
			.then(async (res) => {
				this.areaLoading = false;
        this.$dialog.message.success('수정되었습니다', {
          position: 'top', timeout: 3000
        });
			}).catch(error => { });
    },
    cancelBtn() {
      this.roleModify = false;
    }
	}
}
</script>

<style lang="scss" scoped>
#input_grey {
	width: 100%;
	height: 2.5rem;
	padding-left: 10px;
}
.v-list{
  background: #171921 !important;
	border: 1px solid #4A4A4A;
}
::v-deep {
  .v-list-item__content{
    color: white;
  }
	// Select Box Height 설정
	.v-text-field--outlined > .v-input__control > .v-input__slot {
		min-height: 35px !important;
	}
	.v-text-field--outlined.v-input--dense.v-text-field--outlined > .v-input__control {
		height: 35px;
	}
}
#table_box {
	max-height: 400px;
	overflow: auto;
	&::-webkit-scrollbar {
    width: 3px;
  }
  &::-webkit-scrollbar-thumb {
    background-color: white;
  }
  &::-webkit-scrollbar-track {
    background-color: #4A4A4A;
  }
}
#role_table {
	width: 100%;
	text-align: center;
	th {
		border-bottom: 1px solid #373737;
		color: #8E8E8E;
		padding: 0.6rem 0.25rem;
	}
	td {
		border-bottom: 1px solid #373737;
		padding: 0.6rem 0.25rem;
		font-size: 0.9rem;
		max-width: 10rem;
	}
	thead {
		display: table;
		width: 100%;
	}
	tbody {
		display: block;
		width: 100%;
		height: 350px;
		overflow-y: auto;
		overflow-x: hidden;
		tr {
			display: table;
			width: 100%;
		}
    .td_availability {
      width: 20%;
    }
		&::-webkit-scrollbar {
			width: 3px;
		}
		&::-webkit-scrollbar-thumb {
			background-color: white;
		}
		&::-webkit-scrollbar-track {
			background-color: #4A4A4A;
		}
	}
}
</style>